import React from "react"
import { FaEdit } from "react-icons/fa"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { movePreviousOrderToCartForEdit } from "utils"
import classes from "./KtOrderCardDropDownEditButton.module.scss"

const KtOrderCardDropDownEditButton = props => {
  const {
    subPaymentItems,
    tableDetails,
    tableOrder
  } = props

  const [t] = useTranslation()

  const history = useHistory()

  const handleTransferPreviosOrderItemsToCart = () => {
    movePreviousOrderToCartForEdit(
      tableOrder,
      tableDetails.tableNumber,
      subPaymentItems
    )

    history.push("/foods")
  }

  return (
    <button
      className={clsx(classes.dropdownItem, classes.marginBottom)}
      onClick={handleTransferPreviosOrderItemsToCart}
    >
      <FaEdit size={16} />
      <span className={classes["dropdownText"]}>
        {t("ویرایش")}
      </span>
    </button>
  )
}

export default KtOrderCardDropDownEditButton